import type { Location } from '@tabbio/types';
import { ALL_LOCATIONS, LOCATION_META } from './country-data';
import { locationSearchText } from './city-names';
import { normalizeSearchText } from './country-names';

/** Map localized search aliases back to the canonical location values we save. */
export function searchCuratedLocations(
  query: string,
  opts: { country?: string; limit?: number } = {},
): Location[] {
  const needle = normalizeSearchText(query);
  if (!needle) return [];

  const country = opts.country?.trim().toLowerCase();
  return ALL_LOCATIONS.flatMap((value): Location[] => {
    const meta = LOCATION_META[value];
    if (!meta || !locationSearchText(value).includes(needle)) return [];
    if (
      country &&
      meta.countryCode.toLowerCase() !== country &&
      meta.countryName.toLowerCase() !== country
    ) {
      return [];
    }
    return [{
      name: meta.city,
      country: meta.countryName,
      countryCode: meta.countryCode,
      displayName: value,
    }];
  }).slice(0, opts.limit ?? 20);
}
